function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { Component } from "react";

var ColumnIcon = /*#__PURE__*/function (_Component) {
  _inherits(ColumnIcon, _Component);

  var _super = _createSuper(ColumnIcon);

  function ColumnIcon(props) {
    _classCallCheck(this, ColumnIcon);

    return _super.call(this, props);
  }

  _createClass(ColumnIcon, [{
    key: "render",
    value: function render() {
      var style = {
        fill: "#aaaaaa",
        stroke: "#f9f9fa",
        strokeWidth: "25px"
      }; // let scale = `scale(${this.props.size / 500})`

      var scale = "scale(1)";
      return /*#__PURE__*/React.createElement("svg", {
        "data-name": "Layer 1",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 503 503",
        height: this.props.size || 50,
        width: this.props.size || 50,
        className: "custom-svg-icon"
      }, /*#__PURE__*/React.createElement("g", {
        transform: scale
      }, /*#__PURE__*/React.createElement("rect", {
        x: "1.5",
        y: "1.5",
        width: "500",
        height: "500",
        style: style
      }), /*#__PURE__*/React.createElement("line", {
        x1: "251.5",
        y1: "251.5",
        x2: "387.42",
        y2: "1.5",
        style: style
      }), /*#__PURE__*/React.createElement("line", {
        x1: "251.5",
        y1: "251.5",
        x2: "402.69",
        y2: "501.5",
        style: style
      }), /*#__PURE__*/React.createElement("line", {
        x1: "251.5",
        y1: "251.5",
        x2: "1.5",
        y2: "95.14",
        style: style
      }), /*#__PURE__*/React.createElement("line", {
        x1: "251.5",
        y1: "251.5",
        x2: "1.5",
        y2: "501.5",
        style: style
      })));
    }
  }]);

  return ColumnIcon;
}(Component);

export default ColumnIcon;